var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:[
    `tw-bg-${_setup.props.bgColor}`,
    typeof _setup.props.padding === 'string' ? `tw-${_setup.props.padding}` : _setup.props.padding,
    { 'tw-rounded-xl lg:tw-rounded-2.5xl': _setup.props.rounded },
  ]},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }